import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography, Container } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

// Rendered by RouteErrorBoundary for a caught 403, so this only ever appears
// after a genuine backend permission check (e.g. viewing someone else's saved
// collections) — not a client-side guess at access.
export default function PermissionDeniedPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm" sx={{ textAlign: "center", mt: 5 }}>
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <LockOutlinedIcon color="error" sx={{ fontSize: 80 }} />
        <Typography variant="h4" fontWeight="bold">
          403 - Access Denied
        </Typography>
        <Typography variant="body1" color="textSecondary">
          You don't have permission to view this page.
        </Typography>
        <Box display="flex" gap={2} mt={2}>
          <Button variant="outlined" onClick={() => navigate("/")}>
            Go Home
          </Button>
          <Button variant="contained" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
